import React from 'react';
import { useCartAdd } from 'src/core/state/cart';
import { MessagesModal } from 'src/components/Modal/MessagesModal';
import { DataStatus } from 'src/core/engine/types';

import { Button } from '../../Button/Button';

import classes from './BasketUpsellItem.scss';

type UpsellActionsLoaderProps = {
    quantity: number | string;
};

export const UpsellActionsLoader: React.FC<UpsellActionsLoaderProps> = ({ quantity }) => {
    const { messages, status, clearMessages } = useCartAdd();
    const pending = status === DataStatus.Pending;

    return (
        <>
            <Button
                type="submit"
                disabled={pending || Number(quantity) <= 0 || quantity === ''}
                className={classes.submitBtn}
            >
                {pending ? 'Please wait..' : 'Add to basket'}
            </Button>
            {messages.length > 0 && (
                <MessagesModal messages={messages} close={clearMessages} title="An error occurred" />
            )}
        </>
    );
};

export default UpsellActionsLoader;
